
export const formatCurrency = (value) => {
    if (value === undefined || value === null) return '$0';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 0,
    }).format(value);
};

export const formatNumber = (value) => {
    if (value === null || value === undefined) return '—';
    return new Intl.NumberFormat('en-US').format(value);
};

/**
 * Converts UPPER_SNAKE_CASE style names to Title Case.
 * e.g. "SINGLE_FAMILY" → "Single Family", "TOWNHOMES" → "Townhomes"
 */
export const formatPropertyStyle = (style) => {
    if (!style) return 'Residential';
    return style
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};
